import DataCard from 'components/data-card/data-card.component';

type CustomerOverviewExtendedAttributesTypes = {
  attributes: { label: string; value: string | number }[];
};

const CustomerOverviewExtendedAttributes = ({
  attributes,
}: CustomerOverviewExtendedAttributesTypes) => {
  return attributes.map(({ label, value }) => (
    <DataCard title={label} key={label} value={value} valueType="string" />
  ));
};

export default CustomerOverviewExtendedAttributes;
